import React, { useState } from 'react';
import { login } from '../api';
import { useLayout } from '../LayoutContext';

const LOGOUT_NOTICES = {
  inactivity: '⏱ You were logged out after 12 hours of inactivity.',
  expired:    '🔒 Your session has expired. Please sign in again.'
};

function LoginPage({ onLogin, logoutReason }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showForgot, setShowForgot] = useState(false);
  const { isMobile } = useLayout();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await login(username, password);
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
      onLogin(data.user);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={isMobile ? 'login-container login-container--mobile' : 'login-container'}>
      <div className="login-card">
        <h1>Timesheet</h1>
        <p className="login-subtitle">Sign in to manage your timesheet</p>

        {/* Session / inactivity notice */}
        {logoutReason && LOGOUT_NOTICES[logoutReason] && (
          <div className="session-notice" role="status">
            {LOGOUT_NOTICES[logoutReason]}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter username"
              required
              autoFocus={!isMobile}
              autoCapitalize="none"
              autoCorrect="off"
              autoComplete="username"
              inputMode="text"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              required
              autoComplete="current-password"
            />
          </div>

          {error && <div className="error-message" role="alert">{error}</div>}

          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <div className="forgot-password">
          <button
            type="button"
            className="btn-link"
            onClick={() => setShowForgot(!showForgot)}
          >
            Forgot Password?
          </button>
          {showForgot && (
            <p className="forgot-message">
              Please contact your system administrator to reset your password.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
